/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Signin_Code_LabelInputs */

const en_signin_code_label = /** @type {(inputs: Signin_Code_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Authenticator code`)
};

/** @type {(inputs: Signin_Code_LabelInputs) => LocalizedString} */
const ar_signin_code_label = en_signin_code_label;

/** @type {(inputs: Signin_Code_LabelInputs) => LocalizedString} */
const he_signin_code_label = en_signin_code_label;

/** @type {(inputs: Signin_Code_LabelInputs) => LocalizedString} */
const ur_signin_code_label = en_signin_code_label;

/** @type {(inputs: Signin_Code_LabelInputs) => LocalizedString} */
const es_signin_code_label = en_signin_code_label;

/** @type {(inputs: Signin_Code_LabelInputs) => LocalizedString} */
const fr_signin_code_label = en_signin_code_label;

/** @type {(inputs: Signin_Code_LabelInputs) => LocalizedString} */
const de_signin_code_label = en_signin_code_label;

/** @type {(inputs: Signin_Code_LabelInputs) => LocalizedString} */
const pt_signin_code_label = en_signin_code_label;

/** @type {(inputs: Signin_Code_LabelInputs) => LocalizedString} */
const hi_signin_code_label = en_signin_code_label;

/** @type {(inputs: Signin_Code_LabelInputs) => LocalizedString} */
const bn_signin_code_label = en_signin_code_label;

/**
* | output |
* | --- |
* | "Authenticator code" |
*
* @param {Signin_Code_LabelInputs} inputs
* @param {{ locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }} options
* @returns {LocalizedString}
*/
export const signin_code_label = /** @type {((inputs?: Signin_Code_LabelInputs, options?: { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Signin_Code_LabelInputs, { locale?: "en" | "ar" | "he" | "ur" | "es" | "fr" | "de" | "pt" | "hi" | "bn" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_signin_code_label(inputs)
	if (locale === "he") return he_signin_code_label(inputs)
	if (locale === "ur") return ur_signin_code_label(inputs)
	if (locale === "es") return es_signin_code_label(inputs)
	if (locale === "fr") return fr_signin_code_label(inputs)
	if (locale === "de") return de_signin_code_label(inputs)
	if (locale === "pt") return pt_signin_code_label(inputs)
	if (locale === "hi") return hi_signin_code_label(inputs)
	if (locale === "bn") return bn_signin_code_label(inputs)
	return /** @type {LocalizedString} */ ("Authenticator code")
});